import loadable from '@loadable/component';

export const LoginPage = loadable(() => import('./LoginPage'));
export const SignupPage = loadable(() => import('./SignupPage'));
export const RegisterHospitalPage = loadable(
  () => import('./RegisterHospitalPage'),
);
export const PasswordSettingPage = loadable(
  () => import('./PasswordSettingPage'),
);
export const PatientPage = loadable(() => import('./PatientPage'));
export const HospitalInfoPage = loadable(() => import('./HospitalInfoPage'));
export const ReservationPage = loadable(() => import('./ReservationPage'));
export const PaymentPage = loadable(() => import('./PaymentPage'));
export const FormPage = loadable(() => import('./FormPage'));
export const FormCreationPage = loadable(() => import('./FormCreationPage'));
export const FormResultDetailPage = loadable(
  () => import('./FormResultDetailPage'),
);
export const FormCollectionCreationPage = loadable(
  () => import('./FormCollectionCreationPage'),
);
export const FormsetDetailPage = loadable(() => import('./FormsetDetailPage'));
export const ProtocolCreationPage = loadable(
  () => import('./ProtocolCreationPage'),
);
export const ProtocolDetailPage = loadable(
  () => import('./ProtocolDetailPage'),
);
export const FormSubmitPage = loadable(() => import('./FormSubmitPage'));
export const FormResultListPage = loadable(
  () => import('./FormResultListPage'),
);
export const PrivacyTermPage = loadable(() => import('./PrivacyTermPage'));
export const UsageTermPage = loadable(() => import('./UsageTermPage'));
export const HomePage = loadable(() => import('./HomePage'));
export const NotFoundPage = loadable(() => import('./NotFoundPage'));
export const RequestResetPasswordPage = loadable(
  () => import('./RequestResetPasswordPage'),
);
export const ResetPasswordPage = loadable(() => import('./ResetPasswordPage'));
